<template lang="pug">
  transition(name="modal")
    .fixed.z-50.inset-0.flex.justify-center.items-center(v-if="value && current.item")
      .cover
      .content
        .bg
          bg.absolute
        .relative.h-full.mx-auto.flex.items-center(class="flex-col justify-between ls:py-6 ls:flex-row ls:justify-center ls:w-11/12")
          .flex.flex-col.justify-center.items-center(class="my-auto h-48 md:h-64 ls:my-0 ls:w-7/12")
              .-mx-16.-mt-16(class="ls:mt-0")
                transition(name="item")
                  img.item-image.mx-auto(v-show="imageLoaded" :class="`item-${current.part}`" :src="itemImageSrc[0]" :srcset="itemImageSrc[1]" v-on:load="imageOnLoad")
          .item-text.text-center(class="w-full ls:w-5/12")
            .mx-auto(class="flex-shrink-0 w-10/12 ls:w-full")
              template(v-if="current.part.match(/empty/)")
                h2.mt-4.leading-tight
                  .font-bold.text-bolt(class="text-xl ls:text-2xl") 【{{ current.item.name }}】
              template(v-else)
                .font-bebas.text-lg.text-bolt.tracking-widest ITEM GET!!!
                h2.mt-1.leading-tight
                  .font-bold.text-bolt(class="text-xl ls:text-2xl") 【{{ current.item.name }}】
                  .mt-1 をゲットした！
              p.mt-3.text-sm(class="ls:mt-6" v-html="formatTohtml(current.item.description)")
              .mt-8(class="-mb-8 ls:mb-0")
                router-link(class="w-48 router-link" to="/map") 探索をつづける
</template>
<style lang="sass" scoped>
.item-enter-active
    transition: transform .5s, opacity 0.5s
    will-change: transform, opacity
.item-enter
    opacity: 0
    transform: rotate(360deg) scale(3,3)
.item-text
  ::v-deep
    span
      @apply inline-block
.cover
  @apply absolute inset-0 bg-black opacity-75
.content
  @apply relative max-w-screen-sm mx-auto py-4 w-10/12 mb-8
  height: 62.5vh
  max-height: 35rem
  @screen ls
    @apply max-w-screen-lg
    max-height: 24rem
    height: 50vh
    min-height: 18rem
  @screen lg
    @apply mb-16
.bg
  @apply bg-navy absolute inset-0 rounded-lg overflow-hidden shadow-3xl border border-lightCyan
.item-image
  max-height: 43.75vh
  @screen ls
    max-height: 80vh
.item-head
  @screen pt
    @apply mt-8
.item-bg
  max-height: 37.5vh
  @screen ls
    max-height: 50vh
  @apply rounded-full overflow-hidden
</style>
<script>
import Bg from "@/components/frame/bg";
export default {
  components: {
    Bg
  },
  data() {
    return {
      imageLoaded: false
    };
  },
  methods: {
    imageOnLoad() {
      this.imageLoaded = true;
    }
  },
  watch: {
    value(v) {
      if (!v) this.imageLoaded = false;
    }
  },
  props: ["value", "current"],
  computed: {
    itemImageSrc() {
      const partName = this.current.part.replace(/[0-9]/, "");
      const id = this.$store.state.magrobo[this.current.part];
      const extention = this.current.part === "bg" ? "jpg" : "png";
      const src = [
        `images/magrobo/${partName}-${id}.${extention}`,
        `images/magrobo/${partName}-${id}@2x.${extention} 2x`
      ];
      return src;
    }
  }
};
</script>
